import { useState, useEffect } from "react";
import Login from "../GoogleLogin/Login";
import RouteNav from "../RouteNav/RouteNav";
import Backdrop from "../Backdrop/Backdrop";
import SingleActionModal from "../SingleActionModal/SingleActionModal";
import usePageFocus from "../../utils/usePageFocus";
import { clearAuthetication } from "../../utils/userData";
import "./App.css";
import CONFIG from "../../common/config.json";

const MS_PER_SECOND = 1000;
const TOKEN_EXPIRY_GRACE_MS = 15000;

function App() {
  const [userInfo, dispatchUserInfo] = useState(undefined);
  const [isRefreshUser, setIsRefreshUser] = useState(false);
  let isFocusPage = usePageFocus();

  useEffect(() => {
    const listenToPostMessage = (event) => {
      console.log("Started listening to postMessage!");
      if (
        !window.location.origin === event.origin &&
        !CONFIG.WHITE_LIST_ORIGIN_PROD.ORIGINS.split(",").includes(event?.origin)
      ) {
        console.log("Not allowed origin!");
        return;
      }

      if (event.data?.eventType === "retoolAuthRequired") {
        console.log(
          "Authentication required from Retool: ",
          event.data.payload
        );
        setIsRefreshUser(true);
      }
    };

    window.addEventListener("message", listenToPostMessage);
    return () => window.removeEventListener("message", listenToPostMessage);
  }, []);

  useEffect(() => {
    if (!userInfo) return;

    const expiresInMs = userInfo.exp * MS_PER_SECOND - new Date().getTime();

    // Schedule the sign-out modal for the moment the token expires, plus a
    // 15s grace window for the silent refresh to rescue the session first.
    // A successful refresh dispatches fresh userInfo (new exp), which
    // cancels this timer via cleanup and reschedules with the new expiry.
    const graceTimer = setTimeout(
      () => setIsRefreshUser(true),
      Math.max(expiresInMs, 0) + TOKEN_EXPIRY_GRACE_MS
    );
    return () => clearTimeout(graceTimer);
  }, [isFocusPage, userInfo]);

  // A fresh token arriving after the sign-out warning fired (late rescue via
  // the renewal modal) makes the warning stale — dismiss it
  useEffect(() => {
    if (!userInfo) return;
    if (userInfo.exp * MS_PER_SECOND - new Date().getTime() > TOKEN_EXPIRY_GRACE_MS) {
      setIsRefreshUser(false);
    }
  }, [userInfo]);

  // Login must keep the same tree position in both states: remounting it
  // would drop its in-flight auth state and refetch userInfo a second time
  return (
    <>
      {userInfo && (
        <Backdrop show={isRefreshUser}>
          <SingleActionModal
            headerImgUrl={"/athena-logo.png"}
            title={"You have been signed out"}
            content={
              "Your session has timed out due to inactivity, as required by security policy. Please sign in again to continue using LaunchPad web application."
            }
            actionTitle={"Sign in"}
            actionCallback={() => clearAuthetication(true)}
          />
        </Backdrop>
      )}
      <Login dispatchUserInfo={dispatchUserInfo} />
      {userInfo && <RouteNav userInfo={userInfo} />}
    </>
  );
}

export default App;
